<template>
  <editable-text
    ref="titleInput"
    :text="item.title ?? ''"
    :displayed-text="item.title || placeholder || $t('labels.unnamed')"
    :editable="true"
    :single-line="false"
    class="itemheader__title"
    @update:text="updateTitle($event)"
  />
</template>

<script setup lang="ts" generic="T extends ItemWithTitle">
import { computed } from 'vue';
import { useModelStore } from '@editor/items/model/model.store';
import EditableText from '@core/input/EditableText.vue';
import type { ItemOfStore, ItemWithTitle } from '@editor/items/ItemOfStore';
import type { ItemStoreActions } from '@editor/items/itemStore.store';

const props = defineProps<{
  item: { id: number; type: T; title: string | null },
  placeholder?: string
}>();

const store = computed(() => {
  return useModelStore().getStore(props.item.type as T) as unknown as ItemStoreActions<ItemOfStore<T>>;
});

function updateTitle(newTitle: string) {
  if (!store.value) return;
  store.value.updateKey(props.item.id, "title", newTitle);
}
</script>